<template>
  <v-container pl-12 pr-0 fluid>
    <v-row align="center" justify="center" class="pl-7 pt-6">
      <v-col cols="6" align="center" justify="center">
        <p class="display-2 text-center font-weight-bold indigo--text">Get in Touch</p>
      </v-col>
    </v-row>
    <v-row fluid align="center" justify="center" pl-12>
      <LOC />
    </v-row>
  </v-container>
</template>

<script>
import LOC from '../components/Contact/Location.vue'
export default {
  components:{
    LOC
  }
}
</script>
